import Vue from 'vue'
import Router from 'vue-router'
import { getInfo } from '../api/commonApi'
import { isWxBrowser, goWxLogin } from '../utils/login'
import Qs from 'qs'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: resolve => require(['../views/index'], resolve),
      meta: {
        title: '知贝医疗',
        index: 0
      }
    },
    {
      path: '/doctorOffice',
      name: 'doctorOffice',
      component: resolve => require(['../views/doctor/doctorOffice'], resolve),
      meta: {
        title: '科室列表',
        index: 1
      }
    },
    {
      path: '/doctorList',
      name: 'doctorList',
      component: resolve => require(['../views/doctor/doctorList'], resolve),
      meta: {
        title: '医生列表',
        index: 2
      }
    },
    {
      path: '/doctorDetail',
      name: 'doctorDetail',
      component: resolve => require(['../views/doctor/doctorDetail'], resolve),
      meta: {
        title: '医生详情',
        index: 3
      }
    },
    {
      path: '/doctorComment',
      name: 'doctorComment',
      component: resolve => require(['../views/doctor/doctorComment'], resolve),
      meta: {
        title: '医生评价',
        index: 4
      }
    },
    {
      path: '/doctorSearch',
      name: 'doctorSearch',
      component: resolve => require(['../views/doctor/doctorSearch'], resolve),
      meta: {
        title: '搜索',
        index: 1
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: resolve => require(['../views/order/order'], resolve),
      meta: {
        title: '订单',
        index: 0,
        keepAlive: true
      }
    },
    {
      path: '/orderEdit',
      name: 'orderEdit',
      component: resolve => require(['../views/order/orderEdit'], resolve),
      meta: {
        title: '图文咨询',
        index: 4
        // keepAlive: true
      }
    },
    {
      path: '/appendConsult',
      name: 'appendConsult',
      component: resolve => require(['../views/order/appendConsult'], resolve),
      meta: {
        title: '继续咨询',
        index: 4,
        keepAlive: true
      }
    },
    {
      path: '/orderComment',
      name: 'orderComment',
      component: resolve => require(['../views/order/orderComment'], resolve),
      meta: {
        title: '图文咨询评价',
        index: 3
      }
    },
    {
      path: '/orderPay',
      name: 'orderPay',
      component: resolve => require(['../views/order/orderPay'], resolve),
      meta: {
        title: '图文咨询支付',
        index: 5
      }
    },
    {
      path: '/orderRefund',
      name: 'orderRefund',
      component: resolve => require(['../views/order/orderRefund'], resolve),
      meta: {
        title: '退款详情',
        index: 4
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: resolve => require(['../views/order/orderDetail'], resolve),
      meta: {
        title: '咨询详情',
        index: 4
      }
    },
    {
      path: '/my',
      name: 'My',
      component: resolve => require(['../views/my/my'], resolve),
      meta: {
        title: '我的',
        index: 0
      }
    },
    {
      path: '/myDoctor',
      name: 'myDoctor',
      component: resolve => require(['../views/my/myDoctor'], resolve),
      meta: {
        title: '我的医生',
        index: 1,
        keepAlive: true
      }
    },
    {
      path: '/myCoupon',
      name: 'myCoupon',
      component: resolve => require(['../views/my/myCoupon'], resolve),
      meta: {
        title: '我的优惠券',
        index: 2
      }
    },
    {
      path: '/peopleList',
      name: 'peopleList',
      component: resolve => require(['../views/my/peopleList'], resolve),
      meta: {
        title: '咨询人列表',
        index: 5
      }
    },
    {
      path: '/peopleEdit',
      name: 'peopleEdit',
      component: resolve => require(['../views/my/peopleEdit'], resolve),
      meta: {
        title: '编辑咨询人',
        index: 6
      }
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../views/login/login'], resolve),
      meta: {
        title: '登陆',
        index: 4
      }
    },
    {
      path: '/bindMobile',
      name: 'BindMobile',
      component: resolve => require(['../views/login/bindMobile'], resolve),
      meta: {
        title: '绑定',
        index: 4
      }
    },
    {
      path: '/changePhone',
      name: 'changePhone',
      component: resolve => require(['../views/login/changePhone'], resolve),
      meta: {
        title: '更换手机号码',
        index: 1
      }
    },
    {
      path: '/myService',
      name: 'myService',
      component: resolve => require(['../views/old/service'], resolve),
      meta: {
        title: '联系客服',
        index: 4
      }
    },
    {
      path: '/index',
      name: 'oldIndex',
      component: resolve => require(['../views/old/index'], resolve),
      meta: {
        title: '知贝医疗',
        index: 4
      }
    },
    {
      path: '/doctorindex',
      name: 'oldDoctorIndex',
      component: resolve => require(['../views/old/doctorindex'], resolve),
      meta: {
        title: '知贝',
        index: 4
      }
    },
    {
      path: '/doctorReply',
      name: 'doctorReply',
      component: resolve => require(['../views/old/doctorReply'], resolve),
      meta: {
        title: '详情',
        index: 4
      }
    },
    {
      path: '/choose',
      name: 'choose',
      component: resolve => require(['../views/login/choose'], resolve),
      meta: {
        title: '选择身份',
        index: 0
      }
    },
    {
      path: '/patientDoctorList/:id',
      name: 'oldDoctorList',
      component: resolve => require(['../views/old/doctorList'], resolve),
      meta: {
        title: '详情',
        index: 4
      }
    },
    {
      path: '/patientDoctorInfo/:id',
      name: 'doctorOldReply',
      component: resolve => require(['../views/old/doctorDetail'], resolve),
      meta: {
        title: '详情',
        index: 4
      }
    },
    {
      path: '/QRCode',
      name: 'QRCode',
      component: resolve => require(['../views/QRCode/QRCode'], resolve),
      meta: {
        title: '小助手二维码',
        index: 0
      }
    },
    {
      path: '/patientOfficeList',
      redirect: '/doctorOffice'
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  var u = navigator.userAgent
  if (to.query.flag) {
    sessionStorage.setItem('flag', to.query.flag)
  }
  
  if (u.indexOf('MicroMessenger') > -1) {
    if (to.path.toLowerCase() === '/choose' || to.path.toLowerCase === 'choose') {
    } else if (to.path.toLowerCase() === '/qrcode' || to.path.toLowerCase === 'qrcode') {
    } else {
      if (to.query.token) {
        localStorage.setItem('token', to.query.token)
        delete to.query.token
        router.push({ query: to.query })
      }
      getInfo().then(res => {
        if (res.code === 20000) {
          localStorage.setItem('userId', res.data.id)
        } else {
          localStorage.removeItem('token')
          // goWxLogin(this)
        }
      }).catch(() => {
        localStorage.removeItem('token')
        let queryStr = ''
        if (!to.query.flag && sessionStorage.getItem('flag')) {
          queryStr += '?flag=' + sessionStorage.getItem('flag')
        }
        if (JSON.stringify(to.query) !== '{}') {
          if (queryStr.length > 0) {
            queryStr += '&' + Qs.stringify(to.query)
          } else {
            queryStr += '?' + Qs.stringify(to.query)
          }
        }
        if (u.indexOf('wxwork') > -1) {
          router.push({ name: 'login' })
        } else {
          let returnUrl = to.path + queryStr
          window.location.href = process.env.WX_LOGIN_URL + '?returnUrl=' + returnUrl
        }
        // goWxLogin(this)
      })
    }
  }
  // console.log(`path:${path}, fullPath:${fullPath}, name:${name}, from:${from}, next:${next}`)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js